import React from 'react'
import styled from 'styled-components'
import {getDay} from "../lib/helpers";

const DaySelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content center;
`

const DayCircle = styled.div`
  cursor: pointer;
  background: ${props => props.selected ? '#00d1b2' : 'white'};
  color: ${props => props.selected ? 'white' : 'black'};
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  min-width: 50px;
  border: ${props => props.selected ? 'none' : 'solid 1px #9b9b9b'};
  border-radius: 50%;
  margin: 5px;
`

const EventSelectorContainer = styled.div``
const EventItem = styled.div`
  align-items: center;
  display: flex;
  cursor: pointer;
  background-color: ${props => props.selected ? '#00d1b2' : 'white'};
  border: ${props => props.selected ? 'none' : '1px solid lightgrey'};
  justify-content: space-between;
  padding: 0 20px;
  width: 100%;
  height: 83px;
  border-radius: 12px;
  margin: 4px 0;
  color: ${props => props.selected ? 'white' : 'lightgrey'};
`

const EventTitle = styled.div`
  font-size: 17px;
  font-weight: 500;

`
const EventTime = styled.div`
  font-family: Montserrat;
  font-size: 17px;
  line-height: normal;
`

class TimeForm extends React.Component {
  render () {
    const {handleNextClick, handleBackClick, program, handleChange, handleDaySelect, dayIndex, eventIndex} = this.props

    const events = program.events
    const times = program.events[dayIndex].times
    const isDisabled = eventIndex === null
    const selectedDay = program.events[dayIndex].day

    return (
      <section className="section">
        <div className="columns is-centered">
          <div className="column is-5 is-desktop">
            <h1 className="title is-1">What time works best for you?</h1>
            <div className="column is-12">
              <h2 className="subtitle has-text-centered has-text-grey-light" style={{marginBottom: 10}}>
                Below are our class offerings for {program.name}
              </h2>
              <DaySelectorContainer className="animated zoomIn">
                {events.map((event, i) => {
                  return <DayCircle selected={dayIndex === i} key={i} onClick={() => handleDaySelect(event.day, i)}>{event.day}</DayCircle>
                })}
              </DaySelectorContainer>
            </div>
            <div className="columns" style={{marginTop: 30}}>
              <div className="column">
                <h1 className="title is-4">{getDay(selectedDay)}</h1>
                <EventSelectorContainer className="animated slideInUp">
                  {times.map((time, i) => {
                    return (
                      <EventItem selected={eventIndex === i} key={i} onClick={() => handleChange(time, i)}>
                        <EventTitle>{time.name}</EventTitle>
                        <EventTime>{time.time}</EventTime>
                      </EventItem>
                    )
                  })}
                </EventSelectorContainer>
              </div>
            </div>

            <div className="level">
              <div className="level-left"></div>
              <div className="level-center"></div>
              <div className="level-right">
                <div className="level-item">
                  <a className="button is-outlined is-medium is-uppercase" onClick={() => handleBackClick()}>Back</a>
                </div>
                <div className="level-item">
                  <button disabled={isDisabled} className="button is-primary is-medium is-uppercase" onClick={() => handleNextClick()}>Next</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    )
  }
}

export default TimeForm


// WEBPACK FOOTER //
// ./src/views/TimeForm.js